import { defineComponent as R, ref as c, toRef as $, provide as N, useTemplateRef as w, onBeforeMount as I, watch as i, computed as L, createElementBlock as V, openBlock as k, createBlock as A, createCommentVNode as B, createVNode as C, unref as s, resolveDynamicComponent as P, withCtx as l, createTextVNode as U, toDisplayString as _, renderSlot as m, isRef as K } from "vue";
import { safeLocalStorage as F, REFERENCE_LS_KEYS as O } from "@scalar/helpers/object/local-storage";
import { makeUrlAbsolute as W } from "@scalar/helpers/url/make-url-absolute";
import { redirectToProxy as Y } from "@scalar/oas-utils/helpers";
import { useColorMode as z } from "@scalar/use-hooks/useColorMode";
import { useSeoMeta as H } from "@unhead/vue";
import { useFavicon as j } from "@vueuse/core";
import q from "../components/ApiReferenceLayout.vue.js";
import { NAV_STATE_SYMBOL as G } from "../hooks/useNavState.js";
import { isClient as D } from "./blocks/scalar-request-example-block/helpers/find-client.js";
import { getDocumentName as J } from "./helpers/get-document-name.js";
import { mapConfiguration as g } from "./helpers/map-configuration.js";
import { normalizeContent as Q } from "./helpers/normalize-content.js";
import { useWorkspaceStoreEvents as X } from "./hooks/use-workspace-store-events.js";
import { useMultipleDocuments as Z } from "../features/multiple-documents/useMultipleDocuments.js";
import ee from "../features/multiple-documents/DocumentSelector.vue.js";
const Ce = /* @__PURE__ */ R({
  __name: "ApiReferenceWorkspace",
  props: {
    configuration: {},
    store: {}
  },
  setup(E) {
    const f = E, {
      availableDocuments: p,
      selectedConfiguration: o,
      selectedDocumentIndex: u,
      isIntersectionEnabled: d,
      hash: x,
      hashPrefix: M
    } = Z({
      configuration: $(f, "configuration"),
      isIntersectionEnabled: c(!1),
      hash: c(""),
      hashPrefix: c("")
    }), y = (e, t) => fetch(
      Y(o.value.proxyUrl, e.toString()),
      t
    );
    N(G, { isIntersectionEnabled: d, hash: x, hashPrefix: M });
    const v = w("root"), r = f.store;
    I(() => {
      const e = F().getItem(
        O.SELECTED_CLIENT
      );
      D(e) && !r.workspace["x-scalar-default-client"] && r.update("x-scalar-default-client", e);
    });
    const S = async (e) => {
      var n;
      const t = Q(e.content), a = J({
        name: e.slug || e.title,
        url: e.url,
        document: t
      });
      if (r.workspace.documents[a]) {
        t && (d.value = !1, r.replaceDocument(a, t), r.update("x-scalar-active-document", a), setTimeout(() => {
          d.value = !0;
        }, 300));
        return;
      }
      if (t)
        return await r.addDocument({
          name: a,
          document: t,
          config: g(e)
        });
      if (e.url)
        return await r.addDocument({
          name: e.slug ?? "default",
          url: W(e.url, {
            basePath: (n = o.value.pathRouting) == null ? void 0 : n.basePath
          }),
          fetch: e.fetch ?? y,
          config: g(e)
        });
    };
    i(
      [
        () => o.value.slug,
        () => o.value.url,
        () => o.value.content
      ],
      ([e, t, a]) => {
        (e || t || a) && S(o.value);
      },
      { immediate: !0 }
    ), X(r, v), i(
      () => o.value.defaultHttpClient,
      (e) => {
        if (e) {
          const { targetKey: t, clientKey: a } = e, n = `${t}/${a}`;
          D(n) && r.update("x-scalar-default-client", n);
        }
      },
      { immediate: !0 }
    );
    const { toggleColorMode: h, isDarkMode: b } = z({
      initialColorMode: o.value.darkMode ? "dark" : void 0,
      overrideColorMode: o.value.forceDarkModeState
    });
    i(
      () => o.value.darkMode,
      (e) => r.update("x-scalar-dark-mode", !!e)
    ), i(
      () => b.value,
      (e) => r.update("x-scalar-dark-mode", e),
      { immediate: !0 }
    ), i(
      () => u.value,
      (e) => {
        var t;
        return r.update(
          "x-scalar-active-document",
          (t = p.value[e]) == null ? void 0 : t.slug
        );
      },
      { immediate: !0 }
    ), o.value.metaData && H(o.value.metaData);
    const T = L(() => o.value.favicon);
    return j(T), (e, t) => {
      var a;
      return k(), V("div", {
        ref_key: "root",
        ref: v
      }, [
        (a = s(o)) != null && a.customCss ? (k(), A(P("style"), { key: 0 }, {
          default: l(() => [
            U(_(s(o).customCss), 1)
          ]),
          _: 1
        })) : B("", !0),
        C(q, {
          configuration: s(o),
          isDark: !!s(r).workspace["x-scalar-dark-mode"],
          store: s(r),
          onToggleDarkMode: t[1] || (t[1] = () => s(h)()),
          onUpdateContent: t[2] || (t[2] = (n) => e.$emit("updateContent", n))
        }, {
          footer: l(() => [
            m(e.$slots, "footer")
          ]),
          "content-end": l(() => [
            m(e.$slots, "footer")
          ]),
          "document-selector": l(() => [
            C(s(ee), {
              modelValue: s(u),
              "onUpdate:modelValue": t[0] || (t[0] = (n) => K(u) ? u.value = n : null),
              options: s(p)
            }, null, 8, ["modelValue", "options"])
          ]),
          "sidebar-start": l(() => [
            m(e.$slots, "sidebar-start")
          ]),
          "sidebar-end": l(() => [
            m(e.$slots, "sidebar-end")
          ]),
          _: 3
        }, 8, ["configuration", "isDark", "store"])
      ], 512);
    };
  }
});
export {
  Ce as default
};
